<script lang="ts">
	import type { EmblaCarouselType } from 'embla-carousel';
	import type { ClassValue } from 'svelte/elements';

	let {
		snapCount,
		currentSnapIndex,
		emblaApi,
		class: className,
	}: {
		snapCount: number;
		currentSnapIndex: number;
		emblaApi?: EmblaCarouselType;
		class?: ClassValue;
	} = $props();
</script>

{#if snapCount > 1}
	<div class={['self-center', className]}>
		<div class="flex h-4 w-full items-center justify-center gap-2">
			{#each Array.from({ length: snapCount }, (_, i) => i) as i (i)}
				<button
					class={[
						'h-1.5 cursor-pointer rounded-xs ring-2 ring-black/75 transition-all disabled:cursor-auto',
						currentSnapIndex === i ? 'w-12 bg-white/75' : 'w-6 bg-neutral-400/75',
					]}
					aria-label="slide"
					onclick={() => emblaApi?.scrollTo(i)}
					disabled={currentSnapIndex === i}
				></button>
			{/each}
		</div>
	</div>
{/if}
